/* eslint-disable import/no-unresolved */
import 'javascripts/showroom_jeep_v2/new_vehicle_show';
import 'stylesheets/showroom_jeep_v2/new_vehicle_show';
